import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function SearchIcon({
	width = 16,
	height = 16,
	color = 'currentColor',
	active = false,
	customIconColor,
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3254 11.4569C9.24162 12.2993 7.87958 12.8011 6.40057 12.8011C2.86569 12.8011 0 9.93539 0 6.40054C0 2.86568 2.86569 0 6.40057 0C9.93544 0 12.8011 2.86568 12.8011 6.40054C12.8011 7.8796 12.2994 9.24157 11.457 10.3253L15.7657 14.6342C16.0781 14.9466 16.0781 15.4533 15.7657 15.7657C15.4533 16.0781 14.9466 16.0781 14.6342 15.7657L10.3254 11.4569ZM11.201 6.40047C11.201 9.05157 9.05167 11.2009 6.40055 11.2009C3.74944 11.2009 1.60013 9.05157 1.60013 6.40047C1.60013 3.74937 3.74944 1.60007 6.40055 1.60007C9.05167 1.60007 11.201 3.74937 11.201 6.40047Z"
				fill={color}
			/>
		</svg>
	);
}
